import { __rest, __assign } from 'tslib';
import React from 'react';

var iconSizes = {
    xxs: "10",
    xs: "12",
    sm: "14",
    md: "16",
    lg: "20",
    xl: "24",
    xxl: "28",
    "3xl": "32",
    "4xl": "40",
    "5xl": "48"
};
var SvgIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, viewBox = _a.viewBox, _c = _a.ariaHidden, ariaHidden = _c === void 0 ? true : _c, ariaLabel = _a.ariaLabel, className = _a.className, children = _a.children, _d = _a.focusable, focusable = _d === void 0 ? false : _d, passThrough = __rest(_a, ["size", "viewBox", "ariaHidden", "ariaLabel", "className", "children", "focusable"]);
    var width = iconSizes[size];
    var height = iconSizes[size];
    var SvgProps = {
        viewBox: viewBox,
        "aria-label": ariaLabel,
        "aria-hidden": ariaHidden,
        className: "tw-fill-current".concat(className ? " ".concat(className) : ""),
        height: "".concat(height, "px"),
        width: "".concat(width, "px"),
        focusable: focusable
    };
    return (React.createElement("svg", __assign({ role: "img" }, SvgProps, passThrough), children));
};

export { SvgIcon };
//# sourceMappingURL=SvgIcon.esm.js.map
